export default "__VITE_ASSET__r$wCrqIq__"